import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import {
    getDnhJobs,
    rollbackDnhImport,
    triggerDnhSync,
} from "../../../api/dnhJobs.api";

const useDnhJobs = () => {
    const history = useHistory();
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(50);
    const [totalPages, setTotalPages] = useState(1);

    const [rollbackModal, setRollbackModal] = useState(false);
    const [selectedJobId, setSelectedJobId] = useState("");
    const [rollbackLoading, setRollbackLoading] = useState(false);

    const [syncLoading, setSyncLoading] = useState(false);

    const toggleRollbackModal = () => {
        setRollbackModal(!rollbackModal);
        setSelectedJobId("");
    };

    const fetchJobs = async () => {
        setLoading(true);
        getDnhJobs(pageSize, page, (response) => {
            if (response.status === 200 && response.data) {
                setJobs(response.data.data || []);
                if (response.data.pagination) {
                    setTotalPages(response.data.pagination.totalPages);
                }
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Failed to fetch DNH Jobs");
            }
        });
    };

    useEffect(() => {
        fetchJobs();
    }, [page]);

    const handleTriggerSync = () => {
        setSyncLoading(true);
        triggerDnhSync((response) => {
            setSyncLoading(false);
            if (response.status === 200) {
                toast.success("DNH Sync Triggered Successfully");
                fetchJobs();
            } else {
                toast.error(response.message || "Failed to trigger sync");
            }
        });
    };

    const handleRollback = () => {
        if (!selectedJobId) {
            toast.error("Please select a job to rollback");
            return;
        }
        setRollbackLoading(true);
        rollbackDnhImport(selectedJobId, (response) => {
            setRollbackLoading(false);
            if (response.status === 200) {
                toast.success("Rollback initiated successfully");
                toggleRollbackModal();
                fetchJobs();
            } else {
                toast.error(response.message || "Failed to rollback job");
            }
        });
    };

    const viewDetails = (job) => {
        history.push(`/admin/dnh-job-details/${job.jobId || job.id}`, { job });
    };

    return {
        jobs,
        loading,
        page,
        setPage,
        totalPages,
        rollbackModal,
        toggleRollbackModal,
        selectedJobId,
        setSelectedJobId,
        rollbackLoading,
        handleRollback,
        syncLoading,
        handleTriggerSync,
        viewDetails,
    };
};

export default useDnhJobs;
